import { useEffect } from "react"

/**
 * When open is true, locks body scroll (overflow: hidden).
 * When open becomes false or component unmounts, restores previous overflow.
 * Use in modal components so the background does not scroll while a modal is open.
 */
export function useModalOpen(open: boolean) {
  useEffect(() => {
    if (!open) return
    const prev = document.body.style.overflow
    document.body.style.overflow = "hidden"
    return () => {
      document.body.style.overflow = prev
    }
  }, [open])
}
